/*
  Kolektif · Header araması (<atl-search>) — Dawn details-modal + predictive-search yerine sade bileşen.

  - Panel her açılışta header'ın GERÇEK alt kenarına konur (duyuru çubuğu + kaydırma dahil);
    body'ye taşınır ki header'daki transform/sticky fixed konumu bozmasın.
  - Masaüstü: header altında tam genişlik bant (ürünler 2 sütun + koleksiyonlar); mobil: header
    altından ekran dibine, kendi "Kapat" düğmesiyle.
  - Shopify Predictive Search API (/search/suggest.json). "Ek Ücreti" yardımcı ürünleri gizlenir.
  - Klavye: ↑/↓ sonuçlar arasında, Enter seçileni açar (seçim yoksa /search), Esc kapatır.
    Sonuç sayısı ekran okuyucuya duyurulur.
*/
(function () {
  'use strict';
  if (customElements.get('atl-search')) return;

  var HIDE = /ek[\s-]*(ü|u)cret/i; // sepete sihirbazla giden ek ücret ürünleri aramada görünmez
  var MIN = 2;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(v) {
    var n = Number(v);
    if (!isFinite(n)) return '';
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  class AtlSearch extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.toggle = this.querySelector('.atl-search__toggle');
      this.panel = this.querySelector('.atl-search__panel');
      this.backdrop = this.querySelector('.atl-search__backdrop');
      if (!this.toggle || !this.panel) return;
      this.input = this.panel.querySelector('.atl-search__input');
      this.results = this.panel.querySelector('.atl-search__results');
      this.status = this.panel.querySelector('.atl-search__status');
      this.form = this.panel.querySelector('form');
      this.suggestUrl = ((window.routes && window.routes.predictive_search_url) || '/search/suggest') + '.json';
      this.searchUrl = this.form.getAttribute('action') || '/search';
      this.active = -1;
      // header'daki transform/sticky, fixed paneli header'a göre konumlamasın
      document.body.appendChild(this.backdrop);
      document.body.appendChild(this.panel);

      this._reposition = this.position.bind(this);
      this.toggle.addEventListener('click', () => (this.isOpen() ? this.close(true) : this.open()));
      this.panel.querySelector('.atl-search__close').addEventListener('click', () => this.close(true));
      this.backdrop.addEventListener('click', () => this.close(false));
      this.input.addEventListener('input', () => this.queue());
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.panel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { e.preventDefault(); this.close(true); }
      });
      this.form.addEventListener('submit', (e) => {
        if (!this.input.value.trim()) e.preventDefault();
      });
      // menü/koleksiyon tetikleyicisine basılırsa arama kapanır
      document.addEventListener('click', (e) => {
        if (this.isOpen() && e.target.closest && e.target.closest('.atl-header__burger, .atl-shop-trigger, .atl-discover__trigger, #cart-icon-bubble')) this.close(false);
      });
    }

    isOpen() { return !this.panel.hidden; }

    position() {
      var header = this.closest('.atl-header') || document.querySelector('.atl-header');
      var bottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      this.panel.style.setProperty('--atl-search-top', bottom + 'px');
      this.backdrop.style.setProperty('--atl-search-top', bottom + 'px');
    }

    open() {
      this.position();
      this.panel.hidden = false;
      this.backdrop.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
      document.documentElement.classList.add('atl-search-open');
      document.dispatchEvent(new CustomEvent('atl:search-open'));
      window.addEventListener('resize', this._reposition);
      var self = this;
      // kaydırma kilidi (scrollbar kalkınca) header'ı yeniden yerleştirebilir: bir kare sonra konumu tekrar ölç
      requestAnimationFrame(function () { self.position(); self.input.focus(); self.input.select(); });
      setTimeout(this._reposition, 250);
      if (this.input.value.trim().length >= MIN) this.queue(0);
    }

    close(returnFocus) {
      if (!this.isOpen()) return;
      this.panel.hidden = true;
      this.backdrop.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');
      document.documentElement.classList.remove('atl-search-open');
      window.removeEventListener('resize', this._reposition);
      if (this._ctrl) this._ctrl.abort();
      if (returnFocus) this.toggle.focus();
    }

    queue(delay) {
      clearTimeout(this._timer);
      var q = this.input.value.trim();
      if (q.length < MIN) { this.render(null, q); return; }
      var self = this;
      this._timer = setTimeout(function () { self.fetch(q); }, delay == null ? 180 : delay);
    }

    fetch(q) {
      if (this._ctrl) this._ctrl.abort();
      this._ctrl = new AbortController();
      this.panel.classList.add('is-loading');
      this.setStatus('Aranıyor…');
      var url = this.suggestUrl + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last';
      var self = this;
      window.fetch(url, { signal: this._ctrl.signal, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) {
          self.panel.classList.remove('is-loading');
          if (self.input.value.trim() !== q) return; // bu arada yazı değişti
          self.render((d && d.resources && d.resources.results) || {}, q);
        })
        .catch(function (e) {
          if (e.name === 'AbortError') return;
          self.panel.classList.remove('is-loading');
          self.renderError(q);
        });
    }

    render(res, q) {
      this.active = -1;
      this.input.removeAttribute('aria-activedescendant');
      if (!res) {
        this.results.innerHTML = '';
        this.input.setAttribute('aria-expanded', 'false');
        this.setStatus('');
        return;
      }
      var products = (res.products || []).filter(function (p) {
        return !HIDE.test(p.title || '') && !HIDE.test(p.handle || '');
      }).slice(0, 8);
      var collections = (res.collections || []).slice(0, 5);
      var allUrl = this.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      var n = 0;
      var opt = function () { return 'AtlSearch-opt-' + (n++); };

      if (!products.length && !collections.length) {
        this.results.innerHTML =
          '<p class="atl-search__empty">“' + esc(q) + '” için sonuç bulunamadı. ' +
          '<a href="/collections/all">Tüm ürünlere göz atın</a></p>';
        this.input.setAttribute('aria-expanded', 'false');
        this.setStatus('Sonuç bulunamadı');
        return;
      }

      var html = '<div class="atl-search__grid">';
      if (products.length) {
        html += '<div class="atl-search__col"><p class="atl-search__heading" id="AtlSearch-h-products">Ürünler</p>' +
          '<ul class="atl-search__list" role="group" aria-labelledby="AtlSearch-h-products">' +
          products.map(function (p) {
            var image = (p.featured_image && p.featured_image.url) || p.image || '';
            var was = Number(p.compare_at_price_max) > Number(p.price) ? '<s>' + money(p.compare_at_price_max) + '</s>' : '';
            return '<li role="presentation"><a role="option" id="' + opt() + '" class="atl-search__item" href="' + esc(p.url) + '">' +
              '<span class="atl-search__thumb">' + (image ? '<img src="' + esc(sized(image, 160)) + '" alt="" loading="lazy" width="56" height="70">' : '') + '</span>' +
              '<span class="atl-search__meta"><span class="atl-search__name">' + esc(p.title) + '</span>' +
              '<span class="atl-search__price">' + was + money(p.price) +
              (p.available === false ? '<span class="atl-search__soldout">Tükendi</span>' : '') + '</span></span></a></li>';
          }).join('') + '</ul></div>';
      }
      if (collections.length) {
        html += '<div class="atl-search__col atl-search__col--side"><p class="atl-search__heading" id="AtlSearch-h-cols">Koleksiyonlar</p>' +
          '<ul class="atl-search__links" role="group" aria-labelledby="AtlSearch-h-cols">' +
          collections.map(function (c) {
            return '<li role="presentation"><a role="option" id="' + opt() + '" class="atl-search__link" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
          }).join('') + '</ul></div>';
      }
      html += '</div>';
      html += '<a role="option" id="' + opt() + '" class="atl-search__all" href="' + esc(allUrl) + '"><span>“' + esc(q) + '” için tüm sonuçlar</span><span aria-hidden="true">→</span></a>';
      this.results.innerHTML = html;
      this.input.setAttribute('aria-expanded', 'true');
      this.setStatus(products.length ? products.length + ' ürün bulundu' : collections.length + ' koleksiyon bulundu');
    }

    renderError(q) {
      this.results.innerHTML = '<p class="atl-search__empty">Şu an öneri gösterilemiyor. ' +
        '<a href="' + esc(this.searchUrl + '?q=' + encodeURIComponent(q)) + '">“' + esc(q) + '” için arayın</a></p>';
      this.setStatus('');
    }

    setStatus(t) { if (this.status) this.status.textContent = t; }

    onKey(e) {
      var opts = this.results.querySelectorAll('[role="option"]');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!opts.length) return;
        e.preventDefault();
        var i = this.active + (e.key === 'ArrowDown' ? 1 : -1);
        if (i < 0) i = opts.length - 1;
        if (i >= opts.length) i = 0;
        this.setActive(opts, i);
      } else if (e.key === 'Enter' && this.active >= 0 && opts[this.active]) {
        e.preventDefault();
        window.location.href = opts[this.active].getAttribute('href');
      }
    }

    setActive(opts, i) {
      opts.forEach(function (o) { o.classList.remove('is-active'); o.removeAttribute('aria-selected'); });
      var o = opts[i];
      o.classList.add('is-active');
      o.setAttribute('aria-selected', 'true');
      this.input.setAttribute('aria-activedescendant', o.id);
      o.scrollIntoView({ block: 'nearest' });
      this.active = i;
    }
  }

  customElements.define('atl-search', AtlSearch);
})();
